import {Component, OnInit} from '@angular/core';
import {ReportService} from '../../../../services/authenticated/report/report.service';
import {ResponseModel} from '../../../../models/response/response.model';
import {Emitters} from '../../../../helpers/core/emitters';
import {AssetModel} from '../../../../models/asset/asset.model';
import {FileSystem} from '../../../../helpers/jquery/file.system';

declare var excelExport: any;

@Component({
    selector: 'app-asset-report',
    templateUrl: './asset.report.component.html',
})

export class AssetReportComponent implements OnInit {
    public reportData: Array<AssetModel>;
    public submit_data:any;
    constructor(private reportService: ReportService, private emitters: Emitters) {
    }

    ngOnInit() {
        this.init();
    }

    private init() {
        this.reportData = [];
    }

    // public exportReport() {
    //     const id = 'asset-report';
    //     excelExport(id, id);
    // }

    public exportReport() {
        let data = this.submit_data;
        data['is_export']=1;
        this.onSubmit(data);
    }   

    public onSubmit(data) {
        const dataToSend = { ...data };
        const formatDateTime = (dateTimeStr) => {
            const [datePart, timePart, period] = dateTimeStr.split(' '); 
            const [day, month, year] = datePart.split('/'); 
            return `${month}/${day}/${year} ${timePart} ${period}`;
        };
        if (dataToSend.date) {
            dataToSend.date = formatDateTime(dataToSend.date);
        }
        if (dataToSend.end_date) {
            dataToSend.end_date = formatDateTime(dataToSend.end_date);
        }
        this.submit_data = data;
        this.reportService.asset(dataToSend).then((response: ResponseModel) => {
            if (response.status) {
                if (data['is_export']==1) {
                    FileSystem.downloadFileByGenerateHref(response.data);
                    data['is_export'] = 0;
                } else {
                    this.reportData = response.data.report_data;
                }
                
                this.emitters.change({get_report: true});
            }
        });
    }
}
